import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import PeInput from './PeInput';
import { Field, getFormValues } from 'redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';

import onCheckEmailLead from '../thunks/onCheckEmailLead';
import { LinearProgress } from '@material-ui/core';

import slice from '../states/shell/slice';
import useStyles from '../styles/styles';
import PeMoreInfo from './PeMoreInfo';
import State from '../states/State';
import { formName } from '../thunks/constants';

type PePersonaliseProps = {
    formValues: any
    toolTip: any
}

const PePersonalise: React.FC<PePersonaliseProps> = ({ formValues, toolTip }) => {
    const state = useSelector((state: State) => ({
        leadData: state.shell.leadData,
    }));
    const { isLoading, useDataLead } = state.leadData;

    const [emailValue, setEmailValue] = useState('');
    const classes = useStyles();
    const dispatch = useDispatch();

    const handleBlur = (event: any) => {
        if (event.target.value !== '' && (event.target.value !== emailValue)) {
            dispatch(onCheckEmailLead(event.target.value));
        }
        setEmailValue(event.target.value);
    };

    const handleFocus = (event: any) => {
        if (emailValue && emailValue !== '' && event.target.value === '') setEmailValue('');
    }

    const handleBlurPhone = () => {
        // set scroll target
        dispatch(slice.actions.updateScrollTarget("personal_info"));
    }

    return <div id="node_personal_info" className={classes.paddingBackground}>
        <div className={classes.PePersonalise_labelArea}>
            <h3 className={classes.PePersonalise_label}>Personalise Your Quote</h3>
        </div>
        <div style={{ padding: '0 16px' }}>
            <Grid container>
                <Grid item sm={4} xs={12}>
                    <Field label="Your email"
                        id="your_email"
                        name="your_email"
                        required
                        component={PeInput}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    />
                    {isLoading && <LinearProgress />}
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item sm={4} xs={12}>
                    <Field
                        label="First Name"
                        id="first_name"
                        name="first_name"
                        required
                        component={PeInput}
                        disabled={Boolean(useDataLead)}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <Field
                        label="Last Name"
                        id="last_name"
                        name="last_name"
                        required
                        component={PeInput}
                        disabled={Boolean(useDataLead)}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <Field
                        label="Phone Number"
                        id="phone_number"
                        name="phone_number"
                        required
                        type="tel"
                        component={PeInput}
                        onBlur={handleBlurPhone}
                        disabled={Boolean(useDataLead)}
                    />
                </Grid>
            </Grid>
            <Grid item container spacing={3}>
                <Grid item sm={3} xs={6}>
                    <Field
                        label="Address"
                        id="street_address"
                        name="address"
                        component={PeInput}
                    />
                </Grid>
                <Grid item sm={3} xs={6}>
                    <Field
                        label="State"
                        id="your_state"
                        name="state"
                        component={PeInput}
                    />
                </Grid>
                <Grid item sm={3} xs={6}>
                    <Field
                        label="Locality"
                        id="your_locality"
                        name="locality"
                        component={PeInput}
                    />
                </Grid>
                <Grid item sm={3} xs={6}>
                    <Field
                        label="Postcode"
                        id="your_postcode"
                        name="zip"
                        component={PeInput}
                    />
                </Grid>
            </Grid>
        </div>
        {Boolean(useDataLead) && <div style={{ paddingLeft: 14, paddingRight: 14 }}>
            <PeMoreInfo type="notice" 
            label="Note: If we have identified an existing email address in our database and you would like your Name and Phone Number to be updated, please contact Pure Electric - info@pure-electric or 1300 86 78 73)"/>
        </div>}
    </div>
}

export default connect(state => ({
    formValues: getFormValues(formName)(state)
})
)(PePersonalise);;
